export default __webpack_public_path__ + "static/tooltip-interactive-2-do-light-a919ecad7bd896e73c5ffa76b5a471fa.png";